/**
 * 工程のチェック項目
 */
export default class Subtask {
  public constructor(
    public id: number | string,
    public name: string,
    public done: boolean,
    public dueDate: string,
    public userIds: string[] | number[],
    public projectId: string | number
  ) {}

  toFormData(): FormData {
    const d = new FormData();
    d.append("id", String(this.id));
    d.append("name", this.name);
    d.append("done", String(this.done));
    d.append("dueDate", this.dueDate);
    d.append("userIds", JSON.stringify(this.userIds));
    d.append("projectId", String(this.projectId));
    return d;
  }
}
